/* eslint-disable no-console */
import * as Sentry from '@sentry/browser'
import { register } from 'register-service-worker'

register(`/service-worker.js`, {
	ready: function () {},
	registered: function (registration) {
		setInterval(
			function () {
				registration.update()
			}.bind(registration),
			1000 * 60 * 5
		)
	},
	cached: function () {},
	updatefound: function (registration) {
		Sentry.addBreadcrumb({ category: 'service-worker', message: 'Update found', level: 'info' })
		const newRegistration = registration
		const newServiceWorker = newRegistration.installing
		newServiceWorker.onstatechange = () => {
			if (newServiceWorker.state === 'installed') {
				document.dispatchEvent(new CustomEvent('newServiceWorkerWaiting', { detail: newRegistration }))
			}
		}
		if (newRegistration.waiting) {
			document.dispatchEvent(new CustomEvent('newServiceWorkerWaiting', { detail: newRegistration }))
		}
	},
	updated: function (registration) {
		Sentry.addBreadcrumb({ category: 'service-worker', message: 'Update installed, waiting to activate', level: 'info' })
		if (registration.waiting) {
			document.dispatchEvent(new CustomEvent('newServiceWorkerWaiting', { detail: registration }))
		}
	},
	offline: function () {},
	error: function (error) {
		Sentry.captureException(error)
	}
})
